/* 此文件为自动生成，切换项目时会覆盖
    配置文件： script/project/project/default/index.js
    2023-11-30 17:52:56
*/

export default {
  // Android 下载地址
  AndroidDownload: 'https://fht-app-storage.oss-cn-shenzhen.aliyuncs.com/cy_sbp/com.fht.sbp.cy_release_latest.apk',

  // iOS 下载地址
  iOSDownload: 'http://itunes.apple.com/app/id387682726',

  // scheme协议
  scheme: 'fhstd://',

  appName: '泛和智慧'
}
